var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"showdata"},[_c('vue-seamless-scroll',{attrs:{"data":_vm.Docdata,"class-option":_vm.defaultOption}},[_c('ul',_vm._l((_vm.Docdata),function(item,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(item.userZh)+"--"+_vm._s(item.count)+" ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }